import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';

const ProfileLanguages_1 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          borderTop: '1px solid gray',
          padding: 10,
          textAlign: 'start',
          fontSize: staticValues[14],
          fontWeight: 500,
          color: 'var(--secondaryThemeColor)',
        }}
      >
        Turkish
      </div>
      <div
        style={{
          borderTop: '1px solid gray',
          borderBottom: '1px solid gray',
          padding: 10,
          textAlign: 'start',
          fontSize: staticValues[14],
          fontWeight: 500,
          color: 'var(--secondaryThemeColor)',
        }}
      >
        English
      </div>
    </div>
  );
};

export default ProfileLanguages_1;
